/* global axios */

import ApiClient from '../ApiClient';

class PlaneAPI extends ApiClient {
  constructor() {
    super('integrations/plane', { accountScoped: true });
  }

  getProjects() {
    return axios.get(`${this.url}/projects`);
  }

  getProjectEntities(projectId) {
    return axios.get(`${this.url}/project_entities?project_id=${projectId}`);
  }

  createIssue(data) {
    return axios.post(`${this.url}/create_issue`, data);
  }

  linkIssue(data) {
    return axios.post(`${this.url}/link_issue`, data);
  }

  unlinkIssue(data) {
    return axios.post(`${this.url}/unlink_issue`, data);
  }

  getLinkedIssues(conversationId) {
    return axios.get(
      `${this.url}/linked_issues?conversation_id=${conversationId}`
    );
  }

  searchIssues(query) {
    return axios.get(`${this.url}/search_issue?q=${query}`);
  }
}

export default new PlaneAPI();
